"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _warning = _interopRequireDefault(require("warning"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InputHelperText = function InputHelperText(_ref) {
  var active = _ref.active,
      className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      text = _ref.text,
      restOfProps = _objectWithoutProperties(_ref, ["active", "className", "disabled", "error", "text"]);

  var helperTextClasses = (0, _classnames.default)(className, {
    'pds-input-helper-text': true,
    'pds-input-helper-text--active': active,
    'pds-input-helper-text--error': error,
    'pds-input-helper-text--disabled': disabled
  });
  var helperText = '';
  /**
   * Show the user a warning message for "text" prop not conforming to the proper type
   */

  (0, _warning.default)(Array.isArray(text) || typeof text === 'string', 'PDS::INPUT-HELPER-TEXT: "text" prop should be either a string or an array of strings; using empty string as helperText.');

  if (Array.isArray(text)) {
    helperText = _react.default.createElement("ul", {
      className: "pds-input-helper-text__list"
    }, text.map(function (str) {
      return _react.default.createElement("li", {
        key: str
      }, str);
    }));
  }

  if (typeof text === 'string') {
    helperText = text;
  }

  return _react.default.createElement("div", _extends({}, restOfProps, {
    className: helperTextClasses
  }), helperText);
};

InputHelperText.propTypes = {
  active: _propTypes.bool,
  className: _propTypes.string,
  disabled: _propTypes.bool,
  error: _propTypes.bool,
  text: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.arrayOf)(_propTypes.string)])
};
InputHelperText.defaultProps = {
  active: false,
  className: null,
  disabled: false,
  error: false,
  text: ''
};
var _default = InputHelperText;
exports.default = _default;
